import React, { useState } from 'react'
import { Form } from 'reactstrap'
import IconEnvelope from '../images/icon-envelope.svg'
import TextareaAutosize from 'react-textarea-autosize';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { compose } from "redux";
import gql from "graphql-tag";
import {withTranslations} from "../decorators/with-translations";
import { useMutation } from '@apollo/react-hooks';
import { query as DIALOGUE_QUERY } from '../containers/dialogue-page';
import { query as TOPIC_QUERY } from '../containers/dialogue-page-topic';

const POST_COMMENT = gql`
  mutation PostDialogueComment(
    $surveyId: UUID!
    $parentCommentId: UUID
    $dialogueQuestionID: UUID!
    $input: DialogueCommentInput!
    $languageCode: String
  ) {
    postDialogueComment (
      surveyId: $surveyId
      parentCommentId: $parentCommentId
      dialogueQuestionID: $dialogueQuestionID
      input: $input
      languageCode: $languageCode
    ) {
      id
      likesCount
      text
      createdAt
      respondentColor
      hasLikeByThisRespondent
      isOwnedByThisRespondent
      authorRespondentId
      replies {
        id
        likesCount
        text
        createdAt
        respondentColor
        hasLikeByThisRespondent
        isOwnedByThisRespondent
        authorRespondentId
      }
    }
  }
`;

const DialogueCommentInputfield = ({
  inputRef,
  cancellor,
  parentId,
  autofocus,
  match,
  questionId,
  onCommentFinish,
  useTranslate
}) => {

  const t = (phrase) => useTranslate(`discussion.${phrase}`)
  const [text, setText] = useState('')

  const handleChange = (e) => {
    setText(e.target.value)
  }
  const { params: { surveyId, languageCode, topicId } } = match;

  const refetchVariables = {
    surveyId,
    languageCode
  }

  if (topicId) {
    refetchVariables.topicId = topicId
  }

  const [postComment] = useMutation(
    POST_COMMENT,
    {
      refetchQueries: [{ query: topicId ? TOPIC_QUERY : DIALOGUE_QUERY, variables: refetchVariables }],
      awaitRefetchQueries: true
    }
  )

  const handleComment = () => {
    const variables = {
      surveyId,
      languageCode,
      dialogueQuestionID: questionId,
      input: {
        text
      }
    };

    if (parentId) {
      variables.parentCommentId = parentId
    }

    return postComment({ variables })
      .then(() => {
        setText('')
        onCommentFinish && onCommentFinish()
      })
  }

  return (
    <Form className="add-comment-form">
      <TextareaAutosize
        autoFocus={autofocus}
        ref={inputRef}
        minRows={1}
        placeholder={parentId ? t("reply_field_placeholder") : t("answer_field_placeholder")}
        className="form-control comment-field"
        onChange={handleChange}
        value={text}
      />
      <button
        className="btn btn-submit-comment"
        type='button'
        disabled={!text}
        onClick={handleComment}
      >
        <img src={IconEnvelope} alt="Submit"/><span className="sr-only">{t("submit_answer_screenreader_text")}</span>
      </button>
    </Form>
  )
}

export default compose(
  withRouter,
  withTranslations,
  connect(null, null)
)(DialogueCommentInputfield)



// WEBPACK FOOTER //
// ./src/components/dialogue-comment-inputfield.js